import ReferralSourceAnalytics from './ReferralSourceAnalytics';

export default ReferralSourceAnalytics;
